class Organization {
  constructor(id, abbrev, addresses, description, image, name, website) {
    this.id = id;
    this.name = name;
    this.abbrev = abbrev;
    this.image = image;
    this.description = description;
    this.addresses = addresses;
    this.website = website;
  }
}

export default Organization;
